import BREAKPOINTS from "./BREAKPOINTS";
import getViewportDimensions from "./getViewportDimensions";

export function isMobile(size = getViewportDimensions()) {
  return size.width < BREAKPOINTS.md;
}
